import { Injectable } from "@angular/core";
import { ApiHttpService } from "./api-http.service";
import { Observable } from "rxjs";

@Injectable()
export class FertigationMethodService {
  constructor(private apiHttp: ApiHttpService) {}

  public getAll = (): Observable<FertigationMethod[]> => {
    return this.apiHttp.get<FertigationMethod[]>("fertigationmethods");
  };

  public get = (id: number): Observable<FertigationMethod> => {
    return this.apiHttp.get<FertigationMethod>(`fertigationmethods/${id}`);
  };
}

export interface FertigationMethod {
  id: number;
  name: string;
  isActive: boolean;
  requiresFollowup: boolean;
}



// WEBPACK FOOTER //
// F:/PHAZP5152IS01-4/_work/202/s/src/app/shared/services/fertigation-method.service.ts